/**
 * Image Query Engine — semantic image search queries, nothing else.
 *
 * Expands a category's base terms with the DNA's image style modifier into
 * ready-to-use search strings for a stock provider (Pixabay, Unsplash, …).
 * No provider is integrated here — later code just takes these strings and
 * calls whatever API it wants.
 */

import { getCategory } from './categoryEngine';

/** How each DNA image style flavors a search query. */
const STYLE_MODIFIERS = {
  photo: '',
  illustration: 'illustration',
  flat: 'flat design',
  studio: 'studio shot',
};

/**
 * Build image queries for a template.
 * Returns up to `limit` strings, e.g. ["burger studio shot", "chef studio shot"].
 * imageCount 0 still returns queries — a backdrop image may be wanted later —
 * but callers can use dna.imageCount to decide how many to actually fetch.
 */
export const buildImageQueries = (categoryId, dna, limit = 6) => {
  const cat = getCategory(categoryId);
  const modifier = STYLE_MODIFIERS[dna.imageStyle] ?? '';
  return cat.imageTerms
    .slice(0, limit)
    .map((term) => (modifier ? `${term} ${modifier}` : term));
};

export const listImageStyles = () => Object.keys(STYLE_MODIFIERS);
